export default {
  version: 1,
  themeName: 'laigu',
  theme: {
    seriesCnt: '10',
    backgroundColor: '#ffffff',
    titleColor: '#1d2754',
    subtitleColor: '#6f7592',
    textColorShow: false,
    textColor: '#333',
    markTextColor: '#ffffff',
    color: [
      '#4a9bff',
      '#2ac292',
      '#6ccc3b',
      '#ffd001',
      '#f7a54b',
      '#fa7c63',
      '#646beb',
      '#3858bf',
      '#2e3b9c',
      '#295df1'
    ],
    borderColor: '#eef0f6',
    borderWidth: '0',
    visualMapColor: [
      '#4a9bff',
      '#2ac292',
      '#6ccc3b',
      '#ffd001',
      '#f7a54b',
      '#fa7c63',
      '#646beb',
      '#3858bf',
      '#2e3b9c',
      '#2979f1'
    ],
    legendTextColor: '#1d2754',
    kColor: '#c23531',
    kColor0: '#314656',
    kBorderColor: '#c23531',
    kBorderColor0: '#314656',
    kBorderWidth: 1,
    lineWidth: '2',
    symbolSize: '4',
    symbol: 'emptyCircle',
    symbolBorderWidth: 1,
    lineSmooth: false,
    graphLineWidth: 1,
    graphLineColor: '#aaa',
    mapLabelColor: '#000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444',
    mapBorderColorE: '#444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
      {
        type: 'all',
        name: '通用坐标轴',
        axisLineShow: true,
        axisLineColor: '#1d2754',
        axisTickShow: true,
        axisTickColor: '#6f7592',
        axisLabelShow: true,
        axisLabelColor: '#1d2754',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      },
      {
        type: 'category',
        name: '类目坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: false,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      },
      {
        type: 'value',
        name: '数值坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      },
      {
        type: 'log',
        name: '对数坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      },
      {
        type: 'time',
        name: '时间坐标轴',
        axisLineShow: true,
        axisLineColor: '#333',
        axisTickShow: true,
        axisTickColor: '#333',
        axisLabelShow: true,
        axisLabelColor: '#333',
        splitLineShow: true,
        splitLineColor: ['#ccc'],
        splitAreaShow: false,
        splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
      }
    ],
    axisSeperateSetting: false,
    toolboxColor: '#6f7592',
    toolboxEmpasisColor: '#6f7592',
    tooltipAxisColor: '#eef0f6',
    tooltipAxisWidth: 1,
    timelineLineColor: '#1d2754',
    timelineLineWidth: 1,
    timelineItemColor: '#1d2754',
    timelineItemColorE: '#4a9bff',
    timelineCheckColor: '#2979f1',
    timelineCheckBorderColor: '#2e3b9c',
    timelineItemBorderWidth: 1,
    timelineControlColor: '#1d2754',
    timelineControlBorderColor: '#1d2754',
    timelineControlBorderWidth: 0.5,
    timelineLabelColor: '#1d2754',
    datazoomBackgroundColor: 'rgba(255,255,255,1)',
    datazoomDataColor: '#eef0f6',
    datazoomFillColor: '#eef0f6',
    datazoomHandleColor: '#6f7592',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#1d2754'
  }
};
